<template>
  <div class="indexs">
    <Seacher @search="searchs"></Seacher>

    <!-- <div class="content_top" id="list">
      <div class="head">Overview</div>
      <div class="content_center centers">
        <div class="block_height">
          <div class="block_tit">Token :</div>
          <div class="block_con">
            <img :src="logo" style="border-radius: 50%;" /><span style="margin-top: 6px;">{{ contractName }}</span>
       
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Total Supply :</div>
          <div class="block_con" style="margin-top: 6px;">{{ totalSupply }}</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Holders :</div>
          <div class="block_con" style="margin-top: 6px;">{{ holders }}</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Transfers :</div>
          <div class="block_con" style="margin-top: 6px;">{{ txCount }}</div>
        </div>
        <div class="block_height">
          <div class="block_tit">Contract :</div>
          <div class="block_con blockconss" style="margin-top: 6px;">
            {{ contractAddress }}
          </div>
        </div>
        <div class="block_height">
          <div class="block_tit">Creator :</div>
          <div class="block_con blockw" @click="goDetail('address', creator)">
            {{ creator }}
          </div>
        </div>
      </div>
    </div> -->
    <!-- Overview开始 -->
    <div class="Overview">
      <div class="box">
        <div class="title">Overview</div>
        <div class="boxli">
          <div class="boxlitit" style="margin-top: 5px">Token :</div>
          <div class="boxlicon" style="margin-top: 2px">
            <img class="imga" :src="logo" style="border-radius: 50%" />
            <span style="margin-top: 5px; margin-left: 6px"
              >{{ contractName }}
            </span>
            <span
              v-if="symbol !== null"
              style="margin-top: 5px; margin-left: 2px"
            >
              <span v-if="symbol.trim() !== ''">(</span>
              <span v-if="symbol.trim() !== null || symbol.trim() !== ''">
                {{ symbol }}</span
              >
              <span v-if="symbol.trim() !== ''">)</span>
            </span>
          </div>
        </div>
        <div class="boxli">
          <div class="boxlitit">Token :</div>
          <div class="boxlicon">{{ Number(totalSupply).toLocaleString() }}</div>
        </div>
        <div class="boxli">
          <div class="boxlitit">Holders :</div>
          <div class="boxlicon">{{ Number(holders).toLocaleString() }}</div>
        </div>
        <div class="boxli">
          <div class="boxlitit">Transfers :</div>
          <div class="boxlicon">{{ Number(txCount).toLocaleString() }}</div>
        </div>
      </div>
    </div>
    <div class="Overview">
      <div class="box">
        <div class="title">
          Other Info<img
            class="images"
            v-if="isEditContractInfo == 1"
            src="@/assets/pc/Logo/over3.png"
            @click="update"
          />
        </div>

        <div class="boxli">
          <div class="boxlitit">Contract :</div>
          <div class="boxlicon">
            <div
              style="
                width: 288px;

                text-align: left;

                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              "
            >
              {{ contractAddress }}
            </div>
            <img
              src="@/assets/pc/BkHash/BkHash1.png"
              v-clipboard:copy="contractAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
              class="copys"
            />
          </div>
        </div>
        <div class="boxli">
          <div class="boxlitit">Creator :</div>
          <div class="boxlicon" style="color: #fff">
            <div
              @click="goDetail('address', creator)"
              style="
                width: 288px;

                text-align: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              "
            >
              {{ creator }}
            </div>
            <img
              src="@/assets/pc/BkHash/BkHash1.png"
              v-clipboard:copy="creator"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
              class="copys"
            />
          </div>
        </div>
        <div
          class="boxli"
          style="min-height: 100px"
          v-if="
            this.form.whitepapper !== '' ||
            this.form.medium !== '' ||
            this.form.github !== '' ||
            this.form.reddit !== '' ||
            this.form.telegram !== '' ||
            this.form.facebook !== '' ||
            this.form.linkedin !== '' ||
            this.form.twitter !== '' ||
            this.form.discord !== '' ||
            this.form.opensea !== '' ||
            this.form.officialWebSite !== ''
          "
        >
          <div class="boxlitit">Social :</div>
          <div class="boxlicon">
            <a
              :href="this.form.officialWebSite"
              target="_blank"
              v-if="this.form.officialWebSite !== ''"
            >
              <img
                class="imga"
                v-if="this.form.officialWebSite !== ''"
                src="@/assets/pc/Link/11.png"
              />
            </a>
            <a
              :href="this.form.whitepapper"
              target="_blank"
              v-if="this.form.whitepapper !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/1.png" />
            </a>
            <a
              :href="this.form.github"
              target="_blank"
              v-if="this.form.github !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/3.png" />
            </a>
            <a
              :href="this.form.reddit"
              target="_blank"
              v-if="this.form.reddit !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/4.png" />
            </a>
            <a
              :href="this.form.telegram"
              target="_blank"
              v-if="this.form.telegram !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/5.png" />
            </a>
            <a
              :href="this.form.facebook"
              target="_blank"
              v-if="this.form.facebook !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/6.png" />
            </a>
            <a
              :href="this.form.linkedin"
              target="_blank"
              v-if="this.form.linkedin !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/7.png" />
            </a>
            <a
              :href="this.form.twitter"
              target="_blank"
              v-if="this.form.twitter !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/8.png" />
            </a>
            <a
              :href="this.form.discord"
              target="_blank"
              v-if="this.form.discord !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/9.png" />
            </a>
            <a
              :href="this.form.opensea"
              target="_blank"
              v-if="this.form.opensea !== ''"
            >
              <img class="imga" src="@/assets/pc/Link/10.png" />
            </a>

            <a
              :href="this.form.medium"
              target="_blank"
              v-if="this.form.medium !== ''"
            >
              <img
                class="imga"
                v-if="this.form.medium !== ''"
                src="@/assets/pc/Link/2.png"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Overview开始 -->
    <!-- translist start -->
    <div class="translist">
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="tabbox">
                <ul>
                  <li :class="num == 1 ? 'active' : ''" @click="qiehuan(1)">
                    Transfers
                  </li>
                  <li :class="num == 2 ? 'active' : ''" @click="qiehuan(2)">
                    Holders
                  </li>
                  <li :class="num == 3 ? 'active' : ''" @click="qiehuan(3)">
                    Inventory
                  </li>
                  <li :class="num == 4 ? 'active' : ''" @click="qiehuan(4)">
                    Contract
                  </li>
                </ul>
              </div>
            </div>
            <div class="indexContent">
              <div v-show="num == 1">
                <!-- translist start -->
                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list1">
                          <ul class="block_list_Top1">
                            <li>Hash</li>
                            <li>Type</li>
                            <li>Age</li>
                            <li>From</li>
                            <li>To</li>
                            <li>Amount</li>
                          </ul>
                        </div>
                        <div class="Block_List_center1 notranslate">
                          <ul>
                            <li v-for="(item, index) in list" :key="index">
                              <p @click="Hash(item)">{{ item.txHash1 }}</p>
                              <p>{{ item.functions }}</p>
                              <p>{{ item.tradeTime }}</p>
                              <p
                                @click="
                                  goDetail('address', item.fromEvmAddress)
                                "
                              >
                                {{ item.fromEvmAddress1 }}
                              </p>
                              <p
                                @click="goDetail('address', item.toEvmAddress)"
                              >
                                {{ item.toEvmAddress1 }}
                              </p>
                              <p @click="amoutto(index)" style="color: #fff">
                                <img
                                  :src="item.logo"
                                  style="margin-right: 4px; border-radius: 4px"
                                />{{ item.contractName
                                }}<span v-if="item.standard == 'ERC-721'">
                                  {{ item.tokenAmount }}</span
                                >
                              </p>
                              <!-- <p @click="amoutto(index)" style="color: #fff;cursor: pointer;"><img :src="item.image" style="margin-right: 4px;width:20px;height:20px; margin-top:10px;" />{{ item.contractName }} {{
                        item.tokenAmount
                      }}</p> -->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block" v-if="list.length > 0">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="total"
                    >
                    </el-pagination>
                  </div>
                </div>
                <!-- 当小于长度时候 -->
                <div class="content_img" v-if="list.length == 0">
                  <img src="@/assets/m/noseach.png" />
                </div>

                <!-- translist end -->
              </div>
              <div v-show="num == 2">
                <!-- translist start -->
                <div class="totalcall">
                  A total of {{ Number(total2).toLocaleString() }} holders
                </div>
                <div class="resume-list">
                  <div class="pool_main">
                    <div class="tags">
                      <div class="indexList">
                        <div class="Block_list">
                          <ul class="block_list_Top">
                            <li>Rank</li>
                            <li>Adderss</li>
                            <li>Quantity</li>
                            <li>Percentage</li>
                          </ul>
                        </div>
                        <div class="Block_List_center notranslate">
                          <ul>
                            <li
                              v-for="(item, index) in holdersList"
                              :key="index"
                            >
                              <p>{{ index + 1 }}</p>
                              <p
                                class="grays"
                                @click="goDetail('address', item.ownerAddress)"
                              >
                                <span>{{ item.ownerAddress }} </span>
                              </p>
                              <p class="grays">
                                {{ Number(item.quantity).toLocaleString() }}
                              </p>
                              <p class="grays">{{ item.sum }}%</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="block" v-if="holdersList.length > 0">
                    <el-pagination
                      background
                      small
                      :current-page.sync="pageNum"
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      @current-change="handleCurrentChange"
                      :total="total2"
                    >
                    </el-pagination>
                  </div>
                </div>
                <!-- 当小于长度时候 -->
                <div class="content_img" v-if="holdersList.length == 0">
                  <img src="@/assets/m/noseach.png" />
                </div>

                <!-- translist end -->
              </div>
              <div v-show="num == 3">
                <div class="totalcall">
                  A total of {{ Number(total3).toLocaleString() }} holders
                </div>
                <div class="nftlist">
                  <div
                    class="nft_box"
                    v-for="(item, index) in inventoryList"
                    :key="index"
                  >
                    <div class="nft_img">
                      <img :src="item.image" />
                    </div>
                    <div class="take" @click="TackeId(index)">
                      TokenID :<span> {{ item.tokenId }}</span>
                    </div>
                    <div class="takeid" @click="Tacke(index)">
                      Owner : <span> {{ item.ownerAddress1 }}</span>
                    </div>
                  </div>
                </div>
                <div class="block" v-if="inventoryList.length > 0">
                  <el-pagination
                    background
                    small
                    :current-page.sync="pageNum"
                    :page-size="20"
                    :pager-count="5"
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :total="total3"
                  >
                  </el-pagination>
                </div>
                <!-- 当小于长度时候 -->
                <div class="content_img" v-if="inventoryList.length == 0">
                  <img src="@/assets/m/noseach.png" />
                </div>
              </div>
              <div v-show="num == 4">
                <div class="btnbg" v-if="isChecked == 1">
                  <button
                    :class="activeTab == 'tab1' ? 'changetabs1' : 'changetabs'"
                    @click="changeTab('tab1')"
                  >
                    Code
                  </button>
                  <!-- <button
                    :class="activeTab == 'tab2' ? 'changetabs1' : 'changetabs'"
                    @click="changeTab('tab2')"
                  >
                    Call Contract
                  </button> -->
                </div>
                <!-- address和公钥开始 -->
                <div class="calladdressall" v-show="activeTab == 'tab2'">
                  <div class="calladdress"   v-if="codeaddress !== null">
                    <div style="display: flex; justify-content: flex-end">
                      <img src="@/assets/m/Contract/3.png" />
                      <span class="span3">{{ codeaddress }}</span>
                    </div>
                  </div>
                  <div class="calladdress" @click="Confirm" v-else>
                    <div style="display: flex; justify-content: flex-end">
                      <img src="@/assets/m/Contract/3.png" />
                      <span class="span3">Connect wallet</span>
                    </div>
                  </div>
                  <!-- <div
                    class="calladdress"
                    @click="updateresss"
                    v-if="codeaddress !== null"
                  >
                    <div style="display: flex; margin-left: 16px">
                      <img src="@/assets/m/Contract/1.png" /><span class="span1"
                        >Call address:</span
                      >
                    </div>
                    <div style="display: flex">
                      <span class="span2">{{ codeaddress }}</span>
                      <img src="@/assets/m/Contract/2.png" />
                    </div>
                  </div>
                  <div class="calladdressa" @click="callress" v-else>
                    <div style="display: flex; justify-content: flex-end">
                      <img src="@/assets/m/Contract/3.png" />
                      <span class="span3">Call addrees</span>
                    </div>
                  </div> -->
                </div>
                <div class="calladdressbox" v-show="flogs">
                  <div class="calladdressbox_w">
                    <img
                      src="@/assets/m/Contract/4.png"
                      class="closes"
                      @click="quxiao"
                    />
                    <div class="callbox">
                      <el-form ref="forms" :model="forms" :rules="rules">
                        <div class="putext">
                          <div class="puttit">Address</div>
                          <el-form-item prop="address">
                            <el-input
                              v-model.trim="forms.address"
                              class="inpttext"
                              placeholder="address"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="putext">
                          <div class="puttit">Public key</div>
                          <el-form-item prop="publickey">
                            <el-input
                              v-model.trim="forms.publickey"
                              class="inpttext"
                              placeholder="string"
                            ></el-input>
                            <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
                          </el-form-item>
                        </div>
                        <div class="putextbtn">
                          <div class="cancel" @click="quxiao">Cancel</div>
                          <div class="submit" @click="Confirm">Confirm</div>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
                <!-- address和公钥开始 -->

                <div class="boxlist" v-show="activeTab == 'tab1'">
                  <!-- 验证合约开始 -->
                  <div class="yanz" v-if="isChecked == 0">
                    <div class="yanzl">
                      <img :src="imgnamea" />
                      <div>
                        Contract source code is unverified.l am the
                        <br />creator of the contract,<span @click="goto"
                          >Verify and launch source<br />
                          code</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 验证成功开始 -->
                  <div class="yanbox" v-if="isChecked == 1">
                    <div class="yanbox1">
                      <img :src="imgname" />
                      <div>Contract Source Code Verified (Exact Match)</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">Contract Name :</div>
                      <div class="yanbox2c">{{ contractName }}</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">Compiler Version :</div>
                      <div class="yanbox2c">{{ allVersion }}</div>
                    </div>
                    <div class="yanbox2">
                      <div class="yanbox2t">License :</div>
                      <div class="yanbox2c">{{ license }}</div>
                    </div>
                  </div>
                  <!-- 验证成功结束 -->
                  <!-- 验证合约结束 -->
                  <div>
                    <div
                      class="Contracoent"
                      v-if="
                        (sourceCode !== null || sourceCode !== '') &&
                        isChecked == 1
                      "
                    >
                      contract source code
                    </div>
                    <div
                      class="Contrac_img"
                      v-if="
                        (sourceCode !== null || sourceCode !== '') &&
                        isChecked == 1
                      "
                    >
                      <img
                        src="../../assets/m/home/copy.png"
                        v-clipboard:copy="sourceCode"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      />
                      <!-- <img src="../../assets/m/home/link.png" />
                  <img src="../../assets/m/home/qp.png" /> -->
                    </div>
                    <div
                      class="Contrant"
                      v-if="
                        (sourceCode !== null || sourceCode !== '') &&
                        isChecked == 1
                      "
                    >
                      <editor
                        v-model.trim="sourceCode"
                        @init="editorInit"
                        @input="codeChange"
                        lang="javascript"
                        :options="editorOptions"
                        theme="vibrant_ink"
                      ></editor>
                    </div>
                    <div class="Contracoent">Bytecode</div>
                    <div class="Contrac_img">
                      <img
                        src="../../assets/m/home/copy.png"
                        v-clipboard:copy="byteCode"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      />
                      <!-- <img src="../../assets/m/home/link.png" />
                  <img src="../../assets/m/home/qp.png" /> -->
                    </div>
                    <div class="Contrant">
                      <editor
                        v-model.trim="byteCode"
                        @init="editorInit"
                        @input="codeChange"
                        lang="java"
                        :options="editorOptions"
                        theme="vibrant_ink"
                      ></editor>
                    </div>
                  </div>
                  <!-- 当小于长度时候 -->
                  <div
                    class="content_img"
                    v-if="sourceCode == '' && byteCode == ''"
                  >
                    <img src="@/assets/m/noseach.png" />
                  </div>
                </div>
                <div class="boxlist" v-show="activeTab == 'tab2'">
                  <el-collapse
                    v-model.trim="activeName"
                    accordion
                    @change="handleChangeaa"
                  >
                    <el-collapse-item
                      :name="item.id.toString()"
                      v-for="(item, index) in abiJsonall"
                      :key="index"
                    >
                      <template slot="title">
                        <div class="boxli">
                          <div>{{ item.name }}</div>
                          <img
                            src="@/assets/pc/Contract/link.png"
                            v-clipboard:copy="currentURL + '#&' + item.id"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError"
                            @click="stopCollapse"
                          />
                        </div>
                        <!-- <el-button @click="copyLink()" class="tag">复制链接</el-button> -->
                      </template>
                      <div class="listbox">
                        <!-- <el-form :model="dynamicValidateForm" ref="dynamicValidateForm"> -->
                        <div class="listboxli">
                          <div
                            v-for="(item1, index) in item.inputs"
                            :key="index"
                          >
                            <div class="listboxlitit">
                              {{ item1.name }} <span>(</span>{{ item1.type
                              }}<span>)</span>
                            </div>
                            <!-- <el-form-item :prop="item1.values"> -->
                            <div class="listboxlicon">
                              <input
                                v-model.trim="item1.value"
                                :type="item1.type"
                                :placeholder="item1.type"
                              />
                            </div>
                            <!-- </el-form-item> -->
                          </div>
                          <!-- 新添加的类型为"stateMutability": "payable"的开始 -->
                          <div v-if="item.stateMutability == 'payable'">
                            <div class="listboxlitit">payableValue</div>
                            <!-- <el-form-item :prop="item1.values"> -->
                            <div class="listboxlicon">
                              <input
                                v-model.trim="forma.payableValue"
                                type="number"
                                placeholder="Number"
                              />
                            </div>

                            <!-- </el-form-item> -->
                          </div>
                          <!-- 新添加的类型为"stateMutability": "payable"的开始 -->
                          <div
                            class="call1"
                            :class="{ call: isFormValid(abiJsonall[index]) }"
                            @click="Calls()"
                            v-if="item.inputs.length > 0"
                          >
                            Call
                          </div>

                          <div class="outiput">
                            <div style="display: flex; flex-direction: column">
                              <div style="display: flex">
                                <img
                                  src="@/assets/pc/Contract/left.png"
                                  v-if="item.results !== ''"
                                />

                                <div
                                  class="outtext"
                                  v-for="(item2, index) in item.outputs"
                                  :key="index"
                                >
                                  <span v-if="item.results !== ''"
                                    >{{ item2.name }} {{ item2.type }}</span
                                  >
                                </div>
                              </div>
                              <div class="sucess">
                                <div
                                  v-for="(item3, index) in item.results"
                                  :key="index"
                                >
                                  {{ item3 }}
                                </div>
                              </div>
                            </div>
                            <div class="errors">{{ item.resultser }}</div>
                          </div>
                        </div>
                        <!-- </el-form> -->
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import axios from "axios";
import Editor from "vue2-ace-editor";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";
import Seacher from "@/components/m/Seacher.vue";
import { formatSeconds, getSubStr } from "@/utils/utils";

import {
  AddressDetail,
  TypeTxsList,
  NftDetail,
  NftDetailColumns,
} from "../../assets/server/api.js";
import { listTypea } from "../../utils/utils.js";
const echarts = require("echarts");
export default {
  components: {
    Seacher,
    Editor,
  },
  data() {
    return {
      codeaddress: "",
      flogs: false,
      forms: {
        address: "",
        publickey: "",
      },
      rules: {
        address: [
          {
            required: true,
            message: "address  is required",
            trigger: "change",
          },
          {
            min: 33,
            max: 48,
            message: "Please enter a address between 35 and 48 characters.",
            trigger: "blur",
          },
        ],
        publickey: [
          {
            required: true,
            message: "publickey  is required",
            trigger: "change",
          },
          {
            min: 45,
            message: "Please enter a publickey 45 characters.",
            trigger: "blur",
          },
        ],
      },
      abiJson: "",
      abiJsonall: [],
      abiJsonaa: [],
      abiJsonaaall: [],
      hashValue: "",
      currentURL: "",
      resultsucess: [],
      resulterror: "",
      valuenum: "",
      valuenum1: "",
      forma: {
        deployer: "",
        deployutxo: "",
        name: "",
        type: "",
        inputs: [],
        outputs: [],
        stateMutability: "",
        pubstr: "",
        addr: "",
        payableValue: "",
      },
      inputs: "",
      btnshow: false,
      activeName: "",
      activeTab: "tab1", //开始
      symbol: "",
      ImgUrl: require("@/assets/m/xialax.png"),
      pageSize: 1,
      total: null,
      pageNum: 1,

      pagerCount: 0,
      income: "",
      available: "",
      pay: "",
      tradeNums: "",
      vertificationStake: "",
      trustorStake: "",
      TotalBalance: "",
      address: "",
      addressa: "",
      transferList: [],

      IsShow: false,
      dataid: "",
      valShow: false,
      itemindex: 0,
      itemname: "All",
      itemvalue: "",
      itemall: "",
      typeli: 1,
      num: 1,
      //开始
      IsShow: false,
      valShow: false,
      itemname: "1M",
      itemindex: 0,
      imgname: require("@/assets/pc/TopValidators/TopValidators4.png"),
      imgnamea: require("@/assets/pc/TopValidators/tan.png"),
      ImgUrl: require("@/assets/m/home/xiala.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
      // imgUrl:require('@/assets/pc/Index/indexlogo.png'),
      ImgUrl: require("@/assets/pc/Index/indexlogo.png"),
      editorOptions: {
        // 设置代码编辑器的样式
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },

      //开始
      total2: null,
      total3: null,
      contractName: "",
      creator: "",
      deployutxo: "",
      holders: "",
      logo: require("@/assets/pc/Index/indexlogo.png"),
      sourceCode: "",
      byteCode: "",
      totalSupply: "",
      txCount: "",
      contractAddress: "",
      list: [],
      column: "transfers",
      //holders列表中的内容
      holdersList: [],
      holderCount: "",
      //holders列表中的内容结束
      //Inventory列表开始
      inventoryList: [],
      totalNFT: "",
      isChecked: "",
      license: "",
      compileVersion: "",
      allVersion: "",
      isEditContractInfo: "",
      userId: "",
      form: {
        opensea: "",
        github: "",
        twitter: "",
        discord: "",
        facebook: "",
        reddit: "",
        whitepapper: "",
        telegram: "",
        medium: "",
        linkedin: "",
        officialWebSite: "",
      },
      //Inventory列表结束
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {},
  mounted() {
    // this.initCharts();
    //  console.log(localStorage.getItem("form"));
    this.codeaddress = localStorage.getItem("form");
    //  console.log(this.codeaddress);
    if (localStorage.getItem("form") !== null) {
      this.codeaddress = localStorage.getItem("form");
      this.codeaddress = getSubStr(this.codeaddress, 0, 3);
    }
    this.contractAddress = this.$route.query.contractAddress;
    this.userId = localStorage.getItem("userId");
    //   console.log(this.userId);
    // console.log(this.contractAddress);
    this.GetnftDetail();
    this.getContractTxLists();
    this.currentURL = window.location.href;
    // console.log(this.currentURL);
    if (this.currentURL.indexOf("#&") !== -1) {
      this.currentURL = this.currentURL.split("#&")[0];
    }
    //   console.log("当前连接地址:", this.currentURL);
    this.hashValue = this.$route.hash.substring(2);
    this.activeName = this.hashValue.toString();
    // console.log(this.hashValue);
    // console.log(this.activeName);
    // console.log(this.hashValue.length);
    if (this.hashValue.length > 0) {
      this.num = 4;
      this.activeTab = "tab2";
      this.activeName = this.hashValue.toString();
      // console.log(this.activeName);

      this.getTxList();
      this.valuenum1 = this.activeName;
    }
  },
  watch: {
    deep: true,
    $route(to) {
      // console.log(to);
      this.contractAddress = to.query.contractAddress;
      //this.getaddressDetail();
      this.GetnftDetail();
    },
  },

  destroyed() {},
  methods: {
    quxiao() {
      this.flogs = false;
      this.forms.address = "";
      this.forms.publickey = "";
      this.$nextTick(() => {
        this.$refs.forms.clearValidate();
      });
    },
   async Confirm() {
      try {
        this.address = await window.treeWallet.connect();
        localStorage.setItem("form", this.address);
        this.publickey = await window.treeWallet.getPublicKey();
        localStorage.setItem("forma", this.publickey);
        this.codeaddress = localStorage.getItem("form");
        this.codeaddress = getSubStr(this.codeaddress, 0, 3);
        //     this.$message("Success");
        this.$message("Success");
        //console.log(res);
      } catch (error) {
        console.log(error);
      }
      // this.$refs.forms.validate(async (success) => {
      //   //    if (this.validatePassword()) {
      //   //console.log(this.forms);
      //   if (success) {
      //     localStorage.setItem("form", this.forms.address);
      //     localStorage.setItem("forma", this.forms.publickey);
      //     this.codeaddress = localStorage.getItem("form");
      //     this.codeaddress = getSubStr(this.codeaddress, 0, 3);
      //     this.$message("Success");
      //     this.flogs = false;
      //   } else {
      //     //  this.$refs.form.clearValidate();
      //     this.$message(" This field are not filled in ");
      //     // this.$refs.form.clearValidate();
      //     return false;
      //   }
      // });
    },
    callress() {
      this.flogs = true;
    },
    updateresss() {
      this.flogs = true;
      this.$nextTick(() => {
        this.$refs.forms.clearValidate();
      });
      //console.log(this.form.address);
      this.forms.address = localStorage.getItem("form");
      this.forms.publickey = localStorage.getItem("forma");
    },
    async getTxList() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        userId: "",
      };
      //console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftDetail(formData);
      // console.log(res);
      this.abiJsonaa = res.result.abiJson;
      // console.log(this.abiJsonaa);
      if (this.abiJsonaa !== null) {
        if (this.abiJsonaa.length > 0) {
          // console.log(this.abiJson.length);
          for (var i = 0; i < this.abiJsonaa.length; i++) {
            if (this.abiJsonaa[i].type == "function") {
              this.abiJsonaaall.push(this.abiJsonaa[i]);

              //  console.log(this.abiJson[i].inputs);
              //  console.log(this.abiJson[i].outputs);
            }
          }
          // console.log(this.abiJsonaaall);
          for (var j = 0; j < this.abiJsonaaall.length; j++) {
            this.abiJsonaaall[j].id = j + 1;
            //this.abiJsonaaall[j].results = "";
            if (
              this.abiJsonaaall[j].id == this.activeName &&
              this.abiJsonaaall[j].inputs.length == 0
            ) {
              this.forma.name = this.abiJsonaaall[j].name;
              this.forma.type = this.abiJsonaaall[j].type;
              this.forma.inputs = this.abiJsonaaall[j].inputs;
              this.forma.outputs = this.abiJsonaaall[j].outputs;
              this.forma.stateMutability = this.abiJsonaaall[j].stateMutability;
              this.forma.deployer = res.result.creator;
              this.forma.deployutxo = res.result.deployutxo;
              this.Callsaxios();
            }
          }
          // console.log(this.abiJsonaaall);
          // console.log(this.activeName);
        }
      }
    },
    isFormValid(val) {},
    handleChangeaa(val) {
      // console.log(val);
      this.valuenum = val;
      this.valuenum1 = val;
      // console.log(this.valuenum);
      // // console.log(this.valuenum-1);
      // console.log(this.abiJsonall.length);
      // console.log(this.abiJsonall[0]);

      for (var i = 0; i < this.abiJsonall.length; i++) {
        if (
          this.abiJsonall[i].id == this.valuenum &&
          this.abiJsonall[i].inputs.length == 0
        ) {
          //  console.log("打开连接走这了");
          //  this.forma.contractAddress= this.contractAddress;
          this.forma.name = this.abiJsonall[i].name;
          this.forma.type = this.abiJsonall[i].type;
          this.forma.inputs = this.abiJsonall[i].inputs;
          this.forma.outputs = this.abiJsonall[i].outputs;
          this.forma.stateMutability = this.abiJsonall[i].stateMutability;
          this.forma.deployer = this.creator;
          this.forma.deployutxo = this.deployutxo;
          this.forma.pubstr = localStorage.getItem("forma");
          // console.log(this.forma.pubstr);
          this.forma.addr = localStorage.getItem("form");
          if (this.abiJsonall[i].stateMutability !== "payable") {
            this.forma.payableValue = "";
          }
          this.Callsaxios();
        }
      }
    },
    Calls() {
      // console.log(this.valuenum);
      // console.log(this.forma);
      // console.log(this.abiJsonall.length);
      // console.log(this.abiJsonall[0]);

      for (var i = 0; i < this.abiJsonall.length; i++) {
        if (this.abiJsonall[i].id == this.valuenum) {
          for (var j = 0; j < this.abiJsonall[i].inputs.length; j++) {
            if (this.abiJsonall[i].inputs[j].value == "") {
              this.$message("This field are not filled in ");
              return false;
            }
          }
          if (
            this.abiJsonall[i].stateMutability == "payable" &&
            !this.isValidNumber(this.forma.payableValue)
          ) {
            this.$message(
              "Invalid input for payable value. Please enter a positive number or decimal."
            );
            return false;
          }

          // console.log(this.abiJsonall[i].inputs);
          this.forma.deployer = this.creator;
          this.forma.deployutxo = this.deployutxo;
          // console.log(this.forma.deployer);
          // console.log(this.forma.deployutxo);
          //   deployer: "",
          // deployutxo:"",
          //   this.forma.contractAddress = this.contractAddress;
          this.forma.name = this.abiJsonall[i].name;
          this.forma.type = this.abiJsonall[i].type;
          this.forma.inputs = this.abiJsonall[i].inputs;
          this.forma.outputs = this.abiJsonall[i].outputs;
          this.forma.stateMutability = this.abiJsonall[i].stateMutability;
          this.forma.pubstr = localStorage.getItem("forma");
          this.forma.addr = localStorage.getItem("form");
          //  console.log(this.forma.payableValue);
        }
      }
      // console.log(this.forma);
      this.Callsaxios();
    },
    isValidNumber(value) {
      const regex = /^[+]?\d*\.?\d+$/;
      return regex.test(value);
    },
    Callsaxios() {
      axios
        .post(
          //"http://192.168.1.241:9200/tfscBrowser/contract/saveTempContractInfo",
          //  "http://192.168.1.123:9200/tfscBrowser/contract/callContract",
          "https://explorer.tfsc.io/tfscBrowser/contract/callContract",
          this.forma,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // 请求成功状态为200说明添加成功
          // console.log(res);
          // console.log(res.data.code);
          // console.log(res.data.result);

          if (res.data.code == 200) {
            if (
              res.data.result == null ||
              res.data.result == "" ||
              res.data.result == []
            ) {
              // console.log("我走这里了asdsdf");
              var indexs = this.valuenum1 - 1;
              //  console.log(indexs);
              this.$set(this.abiJsonall, indexs, {
                ...this.abiJsonall[indexs],
                results: ["Success"],
                resultser: "",
              });
            } else {
              // console.log("我走这里了");
              var indexs = this.valuenum1 - 1;
              //  console.log(indexs);
              this.$set(this.abiJsonall, indexs, {
                ...this.abiJsonall[indexs],

                results: res.data.result,
                resultser: "",
              });
            }

            // this.abiJsonall[indexs].results = res.data.result;
            // console.log(this.abiJsonall);
          } else if (res.data.code == 400) {
            var indexs = this.valuenum1 - 1;
            //  console.log(indexs);
            this.$set(this.abiJsonall, indexs, {
              ...this.abiJsonall[indexs],
              resultser: res.data.result,
              results: "",
            });
            //   console.log(this.abiJsonall);
          }
        })
        .catch((error) => {
          // console.log(error);
          this.$message(" This field are not filled in ");
        });
    },

    stopCollapse(e) {
      //alert(111);
      // console.log(e);
      return e.stopPropagation();
    },

    changeTab(tab) {
      // console.log(tab);
      this.activeTab = tab;
    },
    update() {
      this.$router.push({
        path: "/m/Information",
        query: { userId: this.userId, contractAddress: this.contractAddress },
      });
    },
    goto() {
      this.$router.push("/m/Verify");
      //this.$message("Coming Soon");
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    amoutto(index) {
      let params = {
        contractAddress: this.contractAddress,
        tokenId: this.list[index].tokenAmount,
      };
      // console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
    },
    codeChange(val) {
      val; //console.log(val)
    },
    Hash(query) {
      this.$router.push({
        path: "/m/TransferDetails",
        query: { txHash: query.txHash, type: 8, standard: query.standard },
      });
      // this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });

      // this.$router.push({ path: "/m/TransferDetails" });
    },

    qiehuan(index) {
      this.num = index;
      if (this.num == 1) {
        this.column = "transfers";
        this.pageNum = 1;
        this.GetnftDetail();
      } else if (this.num == 2) {
        this.pageNum = 1;
        this.column = "holders";
        this.GetnftDetail();
      } else if (this.num == 3) {
        this.pageNum = 1;
        this.column = "inventory";
        this.GetnftDetail();
      }
    },

    async GetnftDetail() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        pageNum: this.pageNum,
        pageSize: 20,
        column: this.column,
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftDetailColumns(formData);
      // console.log(res);
      //  this.contractName = res.result.contractName;
      //   this.creator = res.result.creator;
      // this.holders = res.result.holders;
      if (res.result.contractName == "" || res.result.contractName == null) {
        //this.contractName=getSubStr(res.result.contractAddress,0,3);
        this.contractName = res.result.contractName;
      }
      this.total = res.result.count;

      // console.log(this.txCount);
      if (this.num == 1) {
        this.list = res.result.nftTxList;
        //    console.log(this.list);
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].nftNameList !== "") {
            this.list[i].nftNameList = JSON.parse(this.list[i].nftNameList);
            this.list[i].contractName = this.list[i].nftNameList[0];
          }
          if (this.list[i].nftImageList !== "") {
            var images = JSON.parse(this.list[i].nftImageList);
            //  console.log(images);
            this.list[i].logo = images[0];
            if (this.check_is_img(this.list[i].logo) == false) {
              this.list[i].logo = this.ImgUrl;
            }
          } else {
            this.list[i].logo = this.imgurlnft;
          }
          if (
            this.list[i].logo == "" ||
            this.check_is_img(this.list[i].logo) == false
          ) {
            //  console.log(111);
            this.list[i].logo = this.imgurlnft;
          }
          this.list[i].tokenAmount = this.list[i].tokenAmount.split(",")[0];
          this.list[i].txHash1 = getSubStr(this.list[i].txHash, 0, 6);
          this.list[i].fromEvmAddress1 = getSubStr(
            this.list[i].fromEvmAddress,
            0,
            6
          );
          this.list[i].toEvmAddress1 = getSubStr(
            this.list[i].toEvmAddress,
            0,
            6
          );
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      } else if (this.num == 2) {
        this.holdersList = res.result.holderList;
        for (var i = 0; i < this.holdersList.length; i++) {
          this.holdersList[i].sum = (
            (parseFloat(this.holdersList[i].quantity) /
              parseFloat(this.totalSupply)) *
            100
          ).toFixed(6);
          //  console.log( this.holdersList);
        }
        this.total2 = res.result.holderCount;
      } else if (this.num == 3) {
        this.inventoryList = res.result.inventoryList;
        // console.log(this.inventoryList);
        this.total3 = res.result.totalNFT;
        // console.log(this.total3);
        // console.log(this.inventoryList);
        this.totalNFT = res.result.totalNFT;
        for (var i = 0; i < this.inventoryList.length; i++) {
          if (
            this.inventoryList[i].image == "" ||
            this.check_is_img(this.inventoryList[i].image) == false
          ) {
            this.inventoryList[i].image = this.imgurlnft;
          }
          this.inventoryList[i].ownerAddress1 = getSubStr(
            this.inventoryList[i].ownerAddress,
            0,
            6
          );
          // if(this.inventoryList[i].contractName==''){
          //   this.inventoryList[i].contractName=this.inventoryList[i].tfscOwner1;
          // }
        }
        // inventoryList:[],
        // totalNFT:''
      }
    },
    async getContractTxLists() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        userId: localStorage.getItem("userId"),
      };
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await NftDetail(formData);
      this.abiJson = res.result.abiJson;
      // console.log(this.abiJson);
      if (this.abiJson !== null) {
        if (this.abiJson.length > 0) {
          for (var i = 0; i < this.abiJson.length; i++) {
            // console.log(this.abiJson[i].inputs);
            // console.log(JSON.stringify(this.abiJson[i]))
            if (this.abiJson[i].type == "function") {
              this.abiJsonall.push(this.abiJson[i]);
              //  console.log(this.abiJson[i].inputs);
              //  console.log(this.abiJson[i].outputs);
            }
          }
          //   console.log(this.abiJsonall);
          for (var j = 0; j < this.abiJsonall.length; j++) {
            this.abiJsonall[j].id = j + 1;
            this.abiJsonall[j].results = "";
            this.abiJsonall[j].resultser = "";
            if (this.abiJsonall[j].inputs.length > 0) {
              for (var n = 0; n < this.abiJsonall[j].inputs.length; n++) {
                this.abiJsonall[j].inputs[n].value = "";
                // this.abiJsonall[j].inputs[n].results="";
                //this.abiJsonall[j].inputs[n].values ='value'+j+n;
              }
            }
          }
          //   console.log(this.abiJsonall);
        }
      }
      //   console.log(this.abiJsonall);
      //  console.log(res);
      this.isEditContractInfo = res.result.isEditContractInfo;
      if (
        res.result.socialProfiles !== " " ||
        res.result.socialProfiles !== null
      ) {
        // this.socialProfiles=res.result.socialProfiles;
        this.socialProfiles = JSON.parse(res.result.socialProfiles);
        //  console.log(this.socialProfiles);
        if (this.socialProfiles !== null) {
          this.form.opensea = this.socialProfiles.opensea;
          this.form.github = this.socialProfiles.github;
          //  console.log(this.form.github);
          this.form.twitter = this.socialProfiles.twitter;
          this.form.discord = this.socialProfiles.discord;
          this.form.facebook = this.socialProfiles.facebook;
          this.form.reddit = this.socialProfiles.reddit;
          this.form.whitepapper = this.socialProfiles.whitepapper;
          // console.log(this.form.whitepapper);
          this.form.telegram = this.socialProfiles.telegram;
          this.form.medium = this.socialProfiles.medium;
          this.form.linkedin = this.socialProfiles.linkedin;
          this.form.officialWebSite = this.socialProfiles.officialWebSite;
        }
      }

      this.creator = res.result.creator;
      this.deployutxo = res.result.deployutxo;
      //  console.log(this.creator);
      this.holders = res.result.holders;
      //  console.log(this.holders);
      this.sourceCode = res.result.sourceCode;
      //  console.log(this.sourceCode);
      this.byteCode = res.result.byteCode;
      this.txCount = res.result.txCount;
      this.isChecked = res.result.isChecked;
      //    console.log(this.isChecked);
      this.license = res.result.license;
      this.compileVersion = res.result.compileVersion;
      this.allVersion = res.result.allVersion;
      //    this.contractName = res.result.contractName;
      //   console.log(this.txCount);
      this.totalSupply = res.result.totalSupply;
      this.symbol = res.result.symbol;
      // this.contractName = res.result.contractName;
      if (res.result.contractName == "" || res.result.contractName == null) {
        this.contractName = getSubStr(res.result.contractAddress, 0, 3);
      } else {
        this.contractName = res.result.contractName;
      }

      // if (res.result.logo == "") {
      //   this.logo = this.imgUrl;
      // } else {
      //   this.logo = res.result.logo;
      // }
      if (res.result.logo !== null) {
        if (
          res.result.logo == "" ||
          this.check_is_img(res.result.logo) == false
        ) {
          this.logo = this.ImgUrl;
        } else {
          this.logo = res.result.logo;
        }
      }
      //   console.log(this.logo);
    },
    Tacke(Index) {
      //   console.log(Index);
      // let params = {
      //   address: this.inventoryList[Index].tfscOwner,
      // };
      // console.log(params);
      this.$router.push({
        path: "/m/Address",
        query: { address: this.inventoryList[Index].ownerAddress },
      });
    },
    TackeId(Index) {
      //   console.log(Index);
      let params = {
        contractAddress: this.contractAddress,
        tokenId: this.inventoryList[Index].tokenId,
      };
      //    console.log(params);
      this.$router.push({ path: "/m/NFTslistdetail", query: params });
    },
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "8%",
          left: "2%",
          right: "0%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },

    searchs(e) {
      this.address = e.address;
      //this.getaddressDetail();
    },

    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.pageNum1 = currentPage;
      //  console.log(this.pageNum);
      this.GetnftDetail();
      // if (this.typeli == 1) {
      //   this.getaddressDetail();
      // } else if (this.typeli == 2) {
      //   this.shuaixuan(this.itemall);
      // }
    },

    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    goDetail(name, query) {
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });

          break;
      }
    },

    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style>
.ace_content {
  /* border: 1px solid yellow; */
  /* text-align: left; */
}
.ace_scroller {
}
.ace_gutter-cell {
  padding-left: 0px !important;
}
.ace_gutter-cell.ace_error {
  background-image: none !important;
}
.ace_gutter-cell.ace_warning {
  background-image: none !important;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 20px;
  height: 6px;
  /* border-radius: 24px; */
  background: #13161b;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 25px;

  background: #404040;
  transition: color 0.2s ease;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
</style>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  // background: #3c485c;
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: SF Pro Text-Regular, SF Pro Text;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>
<style lang="less" scoped>
.ace_gutter-layer {
  background: #0b0c0f !important;
}
.el-pagination {
  padding-bottom: 32px !important;
  margin-top: 32px;
}
.indexs {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;

  .Overview {
    margin: 30px auto 0px auto;
    width: 702px;
    // height: 646px;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    padding-bottom: 30px;
    .box {
      width: 678px;
      margin: 0 auto;
      .title {
        height: 80px;
        font-size: 30px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 80px;
        margin-left: 24px;

        text-align: left;
        .images {
          width: 40px;
          height: 40px;
          margin-top: 26px;
          margin-left: 440px;
        }
      }
      .boxli:last-child {
        border-bottom: none;
      }
      .boxli {
        border-bottom: 1px solid #22252e;
        display: flex;
        flex-direction: column;
        height: 140px;

        .boxlitit {
          margin-left: 24px;
          text-align: left;
          margin-top: 30px;
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
        }
        .boxlicon {
          display: flex;
          margin-left: 24px;
          margin-top: 17px;
          font-size: 26px;
          font-family: Roboto, Roboto;
          font-weight: 400;
          color: #898b8d;
          width: 678px;
          flex-wrap: wrap;
          //border: 1px solid red;
          img {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            opacity: 1;
            // margin-right: 34px;
            margin-bottom: 30px;
          }
          .imga {
            width: 50px;
            height: 50px;
          }
        }
      }
    }
  }
  // .content_top {
  //   margin: 30px auto 0px auto;
  //   width: 702px;
  //   background: #0b0c0f;
  //   border-radius: 24px 24px 24px 24px;
  //   opacity: 1;
  // }
  // .head {
  //   width: 702px;
  //   padding: 24px 12px;
  //   // margin:32px 0 32px 32px;
  //   background: #0b0c0f;
  //   opacity: 1;
  //   border-radius: 16px 16px 16px 16px;
  //   padding-left: 30px;
  //   text-align: left;
  //   height: 48px;
  //   font-size: 32px;
  //   font-family: SF Pro Text-Medium, SF Pro Text;
  //   font-weight: 500;
  //   color: rgba(255, 255, 255, 0.9);
  //   line-height: 48px;
  //   span {
  //     font-size: 26px;
  //     font-family: "PingFang SC-中黑体, PingFang SC";
  //     font-weight: normal;
  //     color: #b2b7c2;
  //     line-height: 36px;
  //   }
  // }
  // .content_center {
  //   text-align: left;
  //   padding: 40px 0px 40px 0px;
  //   font-size: 26px;
  //   font-family: SF Pro Text-Medium, SF Pro Text;
  //   font-weight: normal;
  //   color: #adb0c7;
  //   // line-height: 36px;
  //   // border-bottom: 1px solid #3c485c;
  //   margin: 0px 32px;
  //   .borernone {
  //     border-bottom: none !important;
  //   }
  //   .bkheight {
  //     height: 140px !important;
  //   }
  //   .block_height {
  //     height: 122px;
  //     margin-top: 28px;
  //     border-bottom: 1px solid #22252e;
  //     .block_tit {
  //       font-size: 26px;
  //       font-family: PingFang SC-Medium, PingFang SC;
  //       font-weight: 500;
  //       color: #8a8a8a;
  //       height: 36px;
  //       line-height: 36px;
  //     }
  //     .block_con {
  //       font-size: 26px;
  //       font-family: PingFang SC-Regular, PingFang SC;
  //       font-weight: 400;
  //       color: #8a8a8a;
  //       height: 36px;
  //       line-height: 36px;
  //       margin-top: 12px;
  //       display: flex;
  //       span {
  //         height: 36px;
  //         font-size: 26px;
  //         font-family: PingFang SC-Regular, PingFang SC;
  //         font-weight: 400;
  //         color: #898b8d;
  //         line-height: 36px;
  //         margin-left: 10px;
  //       }
  //       .block_hasha {
  //         width: 334px;
  //         height: 72px;
  //         font-size: 26px;
  //         font-family: PingFang SC-Regular, PingFang SC;
  //         font-weight: 400;
  //         color: #8a8a8a;
  //         line-height: 36px;
  //         word-wrap: break-word;
  //         margin-right: 160px;
  //       }
  //       .block_hash {
  //         width: 565px;
  //         height: 72px;
  //         font-size: 26px;
  //         font-family: PingFang SC-Regular, PingFang SC;
  //         font-weight: 400;
  //         color: #8a8a8a;
  //         line-height: 36px;
  //         word-wrap: break-word;
  //       }
  //       img {
  //         width: 60px;
  //         height: 60px;
  //         margin-left: 10px;
  //       }
  //     }
  //     .blockw {
  //       color: #fff !important;
  //     }
  //     .blockconss {
  //       word-break: break-all;
  //     }
  //   }
  // }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      span {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
    }
    //轮播图片开始
    .totalcall {
      text-align: left;
      font-size: 24px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #898b8d;
      margin-left: 24px;
      margin-bottom: 24px;
    }
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        //display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        // width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        // overflow: hidden;
        // border: 1px solid red;
        width: 702px;
        .tabbox {
          height: 90px;
          display: flex;
          margin-top: 24px;
          margin-left: 24px;
          margin-bottom: 24px;
          overflow: hidden;
          ul::-webkit-scrollbar {
            display: none;
          }
          ul {
            overflow: auto;
            display: flex;
            li {
              // width: 271px;
              padding-left: 24px;
              padding-right: 24px;
              height: 80px;
              line-height: 80px;
              background: #000000;
              margin-right: 24px;
              opacity: 1;
              border: 4px solid;
              border-radius: 24px 24px 24px 24px;
              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #898b8d;
            }
            .active {
              // width: 254px;
              height: 80px;
              background: linear-gradient(124deg, #324c43 0%, #0d402f 100%);
              border-radius: 16px 16px 16px 16px;
              opacity: 1;

              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #00ffaa;
              line-height: 80px;
              text-align: center;
            }
          }
        }
      }
      .indexContent {
        overflow: hidden;
        //合约切换开始
        .btnbg {
          width: 654px;
          height: 80px;
         // background: #000000;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          // margin: 0 auto;
          margin-left: 30px;
          display: flex;
          .changetabs {
            width: 298px;
            height: 80px;
            font-size: 26px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #898b8d;
            line-height: 80px;
          }
          .changetabs1 {
            width: 298px;
            height: 60px;
            background: #202327;
            border-radius: 8px 8px 8px 8px;
            opacity: 1;
            font-size: 26px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: #00ffaa;
            line-height: 60px;
          }
          /deep/ button {
            border: none;
          }
        }
        .calladdressall {
          display: flex;
          // height: 40px;
          line-height: 40px;
          margin-top: 80px;

          .calladdress,
          .calladdressa {
            display: flex;
            margin-left: 20px;
            margin-top: -20px;
            padding-bottom: 10px;
            img {
              width: 40px;
              height: 40px;
              margin-top: -10px;
            }
            .span1 {
              height: 30px;
              font-size: 26px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #babbbd;
              line-height: 30px;
              margin-top: 0px;
              margin-left: 8px;
            }
            .span2 {
              height: 30px;
              font-size: 26px;
              font-family: Roboto, Roboto;
              font-weight: 500;
              color: #ffffff;
              line-height: 30px;
              margin-left: 20px;
              margin-right: 6px;
            }
            .span3 {
              height: 30px;
              font-size: 26px;
              font-family: Roboto, Roboto;
              font-weight: 500;
              color: #ffffff;
              line-height: 30px;
              margin-left: 8px;
            }
          }
          .calladdressa {
            margin-left: 460px;
          }
        }
        .calladdressbox {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 99;
          // height: 1000px !important;
          background: rgba(0, 0, 0, 0.7);
          width: 100%;
          height: 100%;
          overflow: auto;
          z-index: 9999;
          .calladdressbox_w {
            width: 630px;
            height: 524px;
            background: #13161b;
            border-radius: 24px 24px 24px 24px;
            opacity: 1;
            position: absolute;
            // border: 1px solid red;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 9999;
            .closes {
              width: 48px;
              height: 48px;
              margin-left: 498px;
              margin-top: 24px;
            }
            .callbox {
              width: 550px;
              height: 80px;

              border-radius: 12px 12px 12px 12px;
              opacity: 1;
              margin: 0 auto;
              // margin-top: 30px;
              .putext {
                display: flex;
                flex-direction: column;
                .puttit {
                  width: 550px;
                  text-align: left;
                  height: 33px;
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 0.5);
                  line-height: 33px;
                  margin-bottom: 12px;
                }
                .inpttext {
                  width: 550px;
                  height: 80px;
                  border-radius: 24px 24px 24px 24px;
                  // border: 1px solid red;
                  /deep/.el-input__inner {
                    color: #ffffff !important;
                    width: 550px;
                    height: 80px;
                    background: #000000 !important;
                    border-radius: 24px 24px 24px 24px;
                    opacity: 1;
                    border: none;
                  }
                  /deep/.el-input__inner::placeholder {
                    color: rgba(255, 255, 255, 0.5) !important;
                  }
                }
              }
              .putextbtn {
                display: flex;
                justify-content: space-between;
                .cancel {
                  width: 262px;
                  height: 70px;
                  line-height: 70px;
                  background: #262a31;
                  border-radius: 12px 12px 12px 12px;
                  opacity: 1;
                  text-align: center;
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 500;
                  color: #04bd80;
                }
                .submit {
                  width: 262px;
                  height: 70px;
                  line-height: 70px;
                  text-align: center;
                  background: #04bd80;
                  border-radius: 12px 12px 12px 12px;
                  opacity: 1;
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 500;
                  color: #000000;
                }
              }
            }
          }
        }
        .boxlist {
          // border: 1px  solid green;
          // display: none;
          /* 修改折叠项标题的背景颜色 */
          padding-top: 30px;
          .boxli {
            display: flex;
            justify-content: space-between;

            width: 654px;
            img {
              width: 40px;
              height: 40px;
              margin-top: 22px;
              z-index: 2;
              margin-right: 30px;
              // border: 1px solid red;
            }
          }
          .listbox {
            // border: 1px solid red;
            padding: 0px;
            .listboxli {
              .listboxlitit {
                height: 22px;
                font-size: 28px;
                font-family: Roboto, Roboto;
                font-weight: 400;
                color: #babbbd;
                line-height: 22px;
                margin-top: 24px;
                margin-bottom: 16px;
                text-align: left;
                padding-left: 24px;
              }
              .listboxlicon {
                /deep/ input {
                  width: 606px;
                  height: 84px;
                  border-radius: 10px 10px 10px 10px;
                  opacity: 1;
                  border: 3px solid rgba(137, 139, 141, 0.3);
                  padding-left: 19px;
                  margin-bottom: 24px;
                  color: #fff;
                }
                /deep/ input::placeholder {
                  color: rgba(186, 187, 189, 0.3); /* 设置placeholder颜色 */
                }
              }
              .call1 {
                width: 606px;
                height: 70px;
                line-height: 70px;
                background: #00e79a;
                border-radius: 10px 10px 10px 10px;
                opacity: 1;
                text-align: center;
                margin: 0 auto;
                margin-top: 24px;
                font-size: 28px;
                font-family: Roboto, Roboto;
                font-weight: 500;
                color: #0b0c0f;
                // margin-bottom: 20px;
              }
              // .call1 {
              //   width: 606px;
              //   height: 70px;
              //   line-height: 70px;
              //   background: #55585b;
              //   border-radius: 10px 10px 10px 10px;
              //   opacity: 1;
              //   text-align: center;
              //   margin: 0 auto;
              //   margin-top: 24px;
              //   font-size: 28px;
              //   font-family: Roboto, Roboto;
              //   font-weight: 500;
              //   color: #0b0c0f;
              // }
              .outiput {
                display: flex;
                margin-top: 20px;
                padding-left: 20px;
                img {
                  width: 24px;
                  height: 24px;

                  // margin-top: 2px;
                }
                .outtext {
                  // margin-right: 20px;
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 400;
                  color: #babbbd;
                  line-height: 22px;
                  margin-left: 4px;
                  word-break: break-all;
                }
                .sucess {
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 400;
                  color: #babbbd;
                  line-height: 22px;
                  margin-left: 2px;
                  padding-bottom: 10px;
                  // margin-bottom: 2px;
                  div {
                    height: 44px;
                    line-height: 44px;
                  }
                }
                .errors {
                  font-size: 28px;
                  font-family: Roboto, Roboto;
                  font-weight: 400;

                  color: #d0354c;
                  line-height: 22px;
                  margin-left: 2px;
                  padding-bottom: 10px;
                }
              }
            }
          }

          /deep/.custom-collapse-title {
            background-color: #ffcc00; /* 设置你想要的背景颜色 */
          }

          /* 修改折叠项内容的文字颜色 */
          /deep/.custom-collapse-content {
            color: red; /* 设置你想要的文字颜色 */
          }
          /deep/.el-collapse-item {
            //  background: #0B0C0F !important;
          }
          /deep/.el-collapse-item__wrap {
            background: #13161b !important;
            border: none;
            border-radius: 10px;
            margin-top: -18px;
            width: 654px;
            margin: 0 auto;
            background: #13161b;
            border-radius: 16px 16px 16px 16px;
            opacity: 1;
            margin-bottom: 22px;
            margin-top: -16px;
          }
          /deep/.el-collapse-item__header {
            width: 654px;
            height: 84px;
            line-height: 84px;
            background: #13161b;
            border-radius: 16px 16px 16px 16px;
            opacity: 1;
            border: none;
            margin: 0 auto;
            margin-bottom: 28px;
            font-size: 28px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #babbbd;
            padding-left: 24px;
            // background: #13161b !important;
            // border: none;
            // padding-left: 20px;
            // padding-right: 10px;
            // border-radius: 10px;
            // margin-bottom: 22px;
            // font-size: 16px !important;
            // font-family: Roboto, Roboto !important;
            // font-weight: 400 !important;
            // color: #babbbd;
          }
          /deep/.el-collapse {
            border: none !important;
          }
          /deep/.el-collapse-item__content {
            // padding-left: 20px;
            width: 654px;
            margin: 0 auto;
            background: #13161b;
            border-radius: 16px 16px 16px 16px;
            opacity: 1;
            padding-bottom: 0px;
          }
          /deep/ .el-collapse-item__arrow,
          .el-tabs__nav {
            transform: rotate(90deg);
          }
          // 点击后方向
          /deep/ .el-collapse-item__arrow.is-active {
            transform: rotate(-90deg);
          }
        }
        //合约切换结束
        .Contractit {
          display: flex;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #898b8d;
          line-height: 42px;
          margin-left: 24px;
          .Contrat {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 42px;
          }
          .Contrac {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 42px;
            margin-left: 24px;
          }
        }
        .nftlist {
          width: 702px;
          margin: 0 auto;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          // margin-left: 24px;
          .nft_box {
            //  margin-left: 12px;
            //  margin-right: 12px;
            //  margin-top: 34px;
            margin: 34px 12px;
            text-align: left;
            // margin: 34px 24px;
            .nft_img {
              width: 315px;
              // height: 392px;
              // background: #0052fe;
              border-radius: 16px 16px 16px 16px;
              opacity: 1;
              img {
                width: 315px;
                // height: 392px;
                // background: #0052fe;
                border-radius: 16px 16px 16px 16px;
              }
            }
            .take {
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              margin-top: 24px;
              span {
                color: #fff;
              }
            }
            .takeid {
              margin-top: 16px;
              height: 34px;
              font-size: 24px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 34px;
              span {
                color: #fff;
              }
            }
          }
        }
        .yanz {
          width: 678px;
          height: 175px;
          opacity: 1;
          border-bottom: 1px solid #22252e;
          border-top: 1px solid #22252e;
          .yanzl {
            display: flex;
            margin-left: 28px;
            margin-top: 28px;
            img {
              width: 48px;
              height: 48px;
            }
            div {
              margin-left: 12px;
              word-wrap: break-word;
              word-break: break-all;
              text-align: left;
              font-size: 26px;
              font-family: Source Han Sans-Regular, Source Han Sans;
              font-weight: 400;
              color: #898b8d;
              line-height: 38px;
              span {
                color: #fff;
              }
            }
          }
        }
        .yanbox {
          width: 678px;
          .yanbox1 {
            display: flex;
            margin-left: 28px;
            padding-top: 28px;
            border-top: 1px solid #22252e;
            padding-bottom: 28px;
            border-bottom: 1px solid #22252e;
            img {
              width: 40px;
              height: 40px;
              margin-right: 12px;
            }
            div {
              font-size: 26px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 38px;
            }
          }
          .yanbox2 {
            border-bottom: 1px solid #22252e;
            height: 120px;
            text-align: left;
            .yanbox2t {
              margin-left: 28px;
              margin-top: 28px;
              height: 36px;
              font-size: 26px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              line-height: 36px;
            }
            .yanbox2c {
              margin-left: 28px;
              height: 36px;
              font-size: 26px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #898b8d;
              line-height: 36px;
              margin-top: 12px;
            }
          }
        }
        .Contracoent {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin-left: 24px;
          margin-top: 44px;
        }
        .Contrac_img {
          margin-left: 410px;
          margin-bottom: 24px;
          img {
            width: 60px;
            height: 60px;
            // border: 1px solid red;
            // margin-right: 44px;
            margin-left: 200px;
          }
        }
        .Contrant {
          width: 654px;
          height: 624px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          overflow: hidden;
        }
        .Block_list1 {
          .block_list_Top1 {
            display: flex;
            width: 1900px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 300px;
            }
            li:nth-child(3) {
              width: 400px;
            }
            li:nth-child(4) {
              width: 300px;
            }
            li:nth-child(5) {
              width: 300px;
            }
            li:nth-child(6) {
              width: 200px;
            }
          }
        }
        .Block_List_center1 {
          width: 1900px;
          ul {
            //  height: 620px;
            width: 1900px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
                img {
                  border-radius: 50%;
                  margin-top: 24px;
                  margin-right: 4px;
                  // width: 40px;
                  height: 40px;
                }
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 300px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 300px;
              color: #8a8a8a;
            }
            p:nth-child(3) {
              width: 400px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 300px;
            }
            p:nth-child(5) {
              width: 300px;
            }
            p:nth-child(6) {
              width: 200px;
              color: #8a8a8a;
            }
          }
        }
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 950px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 150px;
            }
            li:nth-child(2) {
              width: 400px;
              margin-right: 30px;
            }
            li:nth-child(3) {
              width: 200px;
            }
            li:nth-child(4) {
              width: 200px;
            }
          }
        }
        .Block_List_center {
          width: 950px;
          ul {
            //  height: 620px;
            width: 950px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
              .grays {
                color: #898b8d;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 150px;
              // overflow: hidden;
              // white-space: nowrap;
              // text-overflow: ellipsis;
              // -o-text-overflow: ellipsis;
              color: #8a8a8a;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 400px;

              margin-right: 30px;
              span {
                display: block;
                width: 380px;
                color: #fff;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              }
            }
            p:nth-child(3) {
              width: 200px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 200px;
              color: #8a8a8a;
            }
          }
        }
        .Block_list3 {
          .block_list_Top3 {
            display: flex;
            width: 1200px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 300px;
            }
            li:nth-child(2) {
              width: 500px;
            }
            li:nth-child(3) {
              width: 400px;
            }
          }
        }

        .Contractit {
          display: flex;
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #898b8d;
          line-height: 42px;
          margin-left: 24px;
          .Contrat {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #898b8d;
            line-height: 42px;
          }
          .Contrac {
            height: 42px;
            font-size: 30px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 42px;
            margin-left: 24px;
          }
        }
        .Contracoent {
          height: 42px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 42px;
          text-align: left;
          margin-left: 24px;
          margin-top: 44px;
        }
        .Contrac_img {
          margin-left: 410px;
          margin-bottom: 24px;
          img {
            width: 60px;
            height: 60px;
            margin-right: 44px;
          }
        }
        .Contrant {
          width: 654px;
          height: 624px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          opacity: 1;
          margin: 0 auto;
          overflow: hidden;
        }

        .Analysis_list {
          width: 654px;
          height: 445px;
          background: #13161b;
          border-radius: 16px 16px 16px 16px;
          //border: 1px solid red;
          opacity: 1;
          margin: 0 auto;
          margin-bottom: 40px;
          .charts {
            .chartshead {
              display: flex;
              justify-content: space-between;
              .charts_title {
                height: 42px;
                font-size: 30px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #898b8d;
                line-height: 42px;
                margin-top: 24px;
                margin-left: 24px;
              }
              .charts_r {
                position: relative;
                top: 28px;
                left: 10px;
                .hombottn {
                  z-index: 99;
                  display: flex;
                  width: 100px;
                  height: 44px;
                  background: #242931;
                  border-radius: 13px 13px 13px 13px;
                  opacity: 1;
                  // margin-top: 20px;
                  margin-right: 20px;
                  div {
                    height: 17px;
                    height: 34px;
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 34px;
                    margin-top: 4px;
                    margin-left: 20px;
                  }
                  img {
                    width: 40px;
                    height: 40px;
                    // margin-top: 5px;
                    margin-left: 2px;
                  }
                }
                .headcontent {
                  width: 100px;
                  height: 108px;
                  background: #15171a;
                  border-radius: 6px 6px 6px 6px;
                  opacity: 1;
                  position: absolute;
                  left: 0px;
                  top: 64px;
                  z-index: 88;
                  ul {
                    // margin: 12px;
                    margin-left: 12px;
                    li:nth-child(1) {
                      margin-top: 5px;
                    }
                    li {
                      height: 21px;
                      line-height: 21px;
                      cursor: pointer;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                      color: #8e9093;
                    }
                    .active {
                      cursor: pointer;
                      color: #00a870;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    background: #232a35;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    .block {
      height: 128px;
      margin-top: 51px;
      margin-bottom: 50px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
    .head {
      display: -webkit-box;
    }
  }
  .headall {
    position: relative;
    .sousu1 {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 0 0;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }
    .sousu {
      height: 56px;
      background: #2c3645;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;

      display: flex;
      margin-top: 24px;
      margin-right: 32px;
      justify-content: space-between;
      align-content: center;
      span {
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 44px;
        margin-left: 16px;
        margin-top: 8px;
        font-size: 24px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.55);
        line-height: 44px;
      }
      img {
        width: 48px;
        height: 48px;
        margin: 0 !important;
        margin-top: 8px !important;
      }
    }

    .headcontent {
      width: 294px;
      background: #2c3645;
      border-radius: 0px 0px 16px 16px;
      opacity: 1;
      position: absolute;
      right: 0px;
      top: 80px;
      ul {
        margin: 12px;
        li {
          height: 44px;
          line-height: 44px;
          font-size: 28px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.9);
        }
        .active {
          color: #00a870;
        }
      }
    }
  }
  .head {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 690px;
    // height: 100px;
    opacity: 1;
    padding-left: 30px;
    text-align: left;
    font-size: 32px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    // line-height: 100px;
    .address {
      width: 400px;
      color: rgba(255, 255, 255, 0.9);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      text-align: left;
      color: rgba(255, 255, 255, 0.9);
      line-height: 100px;
    }
    img {
      width: 45px;
      height: 45px;
      margin: 20px 30px 40px 0px;
    }
  }
  .content_img {
    img {
      width: 476px;
      height: 318px;
      margin: 100px 20px;
    }
  }
}
</style>
